import { useEffect, useState } from "react";
export function useJobProgress(jobId) {
    const [event, setEvent] = useState(null);
    useEffect(() => {
        if (!jobId)
            return;
        const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
        const url = `${proto}//${window.location.host}/api/v1/ws/jobs/${jobId}`;
        const ws = new WebSocket(url);
        ws.onmessage = (m) => {
            try {
                const payload = JSON.parse(m.data);
                if (payload.type === "ping")
                    return;
                setEvent((prev) => ({ ...(prev ?? {}), ...payload }));
            }
            catch {
                // ignore malformed frames
            }
        };
        ws.onerror = () => {
            // swallow; reconnect logic could be added in Phase 6
        };
        return () => {
            try {
                ws.close();
            }
            catch {
                // ignore
            }
        };
    }, [jobId]);
    return event;
}
